import { ExternalLink, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useLanguage } from "@/hooks/useLanguage";

const COOKIE_NAME = "topbar_dismissed";

function isTopBarDismissed(): boolean {
  return document.cookie.split(";").some((c) => c.trim().startsWith(`${COOKIE_NAME}=`));
}

function dismissTopBar() {
  const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${COOKIE_NAME}=1; expires=${expires}; path=/; SameSite=Lax`;
}

const content = {
  de: { prefix: "🎙️ Nächstes Webinar:", title: "AI für Agenturen: So verkaufst du KI als neuen Service", cta: "Jetzt anmelden", ctaShort: "Anmelden", close: "Schließen" },
  en: { prefix: "🎙️ Next Webinar:", title: "AI for Agencies: How to Sell AI as a New Service", cta: "Register now", ctaShort: "Register", close: "Close" },
};

const TopBar = () => {
  const [visible, setVisible] = useState(true);
  const { language } = useLanguage();
  const c = content[language];

  useEffect(() => {
    setVisible(!isTopBarDismissed());
  }, []);

  if (!visible) return null;

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    dismissTopBar();
    setVisible(false);
  };

  return (
    <div className="bg-accent text-accent-foreground text-xs sm:text-sm font-medium overflow-hidden relative">
      <a href="https://webinar.chathero.ai/" target="_blank" rel="noopener noreferrer" className="block py-1.5 sm:py-2 px-8 sm:px-4 hover:opacity-90 transition-opacity">
        <div className="hidden md:flex items-center justify-center gap-2">
          <span>{c.prefix}</span>
          <span className="font-bold">{c.title}</span>
          <span className="inline-flex items-center gap-1 underline underline-offset-2">{c.cta} <ExternalLink className="w-3 h-3" /></span>
        </div>
        <div className="md:hidden flex items-center">
          <div className="animate-marquee whitespace-nowrap flex items-center gap-8">
            <span className="inline-flex items-center gap-2">{c.prefix} <strong>{c.title}</strong><span className="inline-flex items-center gap-1 underline underline-offset-2 ml-1">{c.ctaShort} <ExternalLink className="w-3 h-3 inline" /></span></span>
            <span className="inline-flex items-center gap-2" aria-hidden="true">{c.prefix} <strong>{c.title}</strong><span className="inline-flex items-center gap-1 underline underline-offset-2 ml-1">{c.ctaShort} <ExternalLink className="w-3 h-3 inline" /></span></span>
          </div>
        </div>
      </a>
      <button onClick={handleClose} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-accent-foreground/10 transition-colors" aria-label={c.close}>
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default TopBar;
